(ns frontend.view.components.form.components.form-integer
  (:require [reagent.core :as r]
            [clojure.string :as string]
            [frontend.view.components.form.components.form-label :as form-label]
            [frontend.utils :as utils]
            [frontend.view.components.form.components.form-cancel-button :as cancel-button]
            [frontend.bootstrap.components :as rbs]
            [frontend.utils :as fu]))

(defn view
  [{:keys [value hide-cancel-button?]}]
  (let [raw-input (r/atom value)
        dom-elem (r/atom nil)
        has-focus (r/atom false)
        negative? (r/atom false)
        error (r/atom nil)]
    (fn [{:keys [entity field label size value intelligence-value wrapper control-id read-only?
                 validate! on-change! on-submit! on-cancel!
                 postfix] :as view-args}]
      (let [on-cancel! (fn [e]
                         (reset! raw-input value)
                         (on-cancel! e))
            on-key-down! (fn [e]
                           (let [key (.-keyCode e)]
                             (when (= key 13)
                               (-> e .-target .blur))       ;; Enter = blur -> save
                             (when (= key 27)               ;; Esc = cancel
                               (on-cancel! e)
                               (-> e .-target .blur))))
            on-submit! (fn [e]
                         (if (or (= @raw-input value)
                                 (nil? @raw-input))
                           (on-cancel! e)
                           (do
                             (on-change! (if (or (js/isNaN @raw-input)
                                                 (= "" @raw-input))
                                           nil
                                           @raw-input))
                             (on-submit! e))))]
        [rbs/Form
         {:class-name "form-integer-form"
          :on-submit  on-submit!
          :on-blur    (fn [e]
                        (let [targetType (-> e .-target .-nodeName)]
                          (when (= targetType "INPUT")
                            (if (:input-validation field)
                              (let [validation-fn (:input-validation field)
                                    input-value (if (or (= @raw-input value) ;; don't validate if field has not changed
                                                        (nil? @raw-input))
                                                  value
                                                  @raw-input)
                                    error-txt (validation-fn input-value)]
                                (reset! error error-txt)
                                (when-not error-txt
                                  (on-submit! e)))
                              (on-submit! e)))))}
         [rbs/FormGroup
          {:control-id control-id
           :size       size
           :class-name (fu/cs wrapper "form__text")}
          (when label
            [form-label/view (merge view-args
                                    {:intelligence-value intelligence-value})])
          [rbs/InputGroup
           [:input {:placeholder ""
                    :ref         (fn [arg]
                                   (reset! dom-elem arg))
                    :type        "text"
                    :id          control-id
                    :class-name  "form-control"
                    :disabled    (boolean read-only?)
                    :value       (let [draw-val (str (let [draw-value (if (nil? @raw-input)
                                                                        (or value intelligence-value)
                                                                        @raw-input)]
                                                       (when draw-value
                                                         (if (= draw-value "")
                                                           (when @negative? "-")
                                                           (string/trim
                                                            (utils/format-with-separators draw-value -1 @negative?))))))]
                                   (str draw-val
                                        ;; only append postfix if the value is not empty
                                        (when (> (count draw-val) 0) postfix)))
                    :on-key-down on-key-down!
                    :on-blur     #(reset! has-focus false)
                    :on-focus    (fn [_]
                                   (reset! has-focus true)
                                   (reset! raw-input nil)
                                   (reset! negative? false)
                                   (set! (.-selectionStart @dom-elem) (max (- (count (-> @dom-elem .-value)) (count (str postfix)))
                                                                           0))
                                   (set! (.-selectionEnd @dom-elem) (max (- (count (-> @dom-elem .-value)) (count (str postfix)))
                                                                         0)))
                    :on-change   (fn [e]
                                   (let [input (-> e .-target .-value)
                                         js-format (string/replace input #"[^-0-9]" "")
                                         int-value (js/parseInt js-format)
                                         neg? (zero? (.indexOf input "-"))
                                         validate-value (if (js/isNaN int-value)
                                                          nil
                                                          int-value)]
                                     (reset! negative? (or neg? false))
                                     (reset! raw-input (if (js/isNaN int-value)
                                                         ""
                                                         int-value))
                                     (when validate!
                                       (validate! validate-value))
                                     (set! (.-selectionStart @dom-elem) (max (- (count (-> @dom-elem .-value)) (count (str postfix)))
                                                                             0))
                                     (set! (.-selectionEnd @dom-elem) (max (- (count (-> @dom-elem .-value)) (count (str postfix)))
                                                                           0))))}]
           (when (and @has-focus (not hide-cancel-button?))
             [cancel-button/view on-cancel!])]
          (when @error
            [:label.zap-form__validation-error @error])]]))))
